module.exports = __webpack_public_path__ + "static/media/02-2-galeria-03-concierge@2x.eb070a39.jpg";